import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface NewReleaseSustainProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const NewReleaseSustain: React.FunctionComponent<React.PropsWithChildren<NewReleaseSustainProps>> = ({
    fill,
    title,
    height,
    width,
    ...rest
}: NewReleaseSustainProps) => (
    <SVGBase viewBox="85 85 165 145" height={height} width={width} title={title} fill={fill} {...rest}>
        <path
            fill="#80AEFF"
            d="M142.39,150.72c0.56-2-0.23-4.09-1.96-5.2c-1.27-0.81-2.8-0.98-4.21-0.44c-1.38,0.52-2.41,1.64-2.81,3.05
					c-4.33,15.33,1.99,32.05,15.38,40.66c2.3,1.48,4.77,2.7,7.33,3.63c1.43,0.52,2.98,0.33,4.24-0.51c0.55-0.36,1-0.82,1.34-1.35
					c0.43-0.67,0.69-1.46,0.73-2.3c0.1-2.06-1.15-3.92-3.12-4.63c-1.91-0.69-3.74-1.6-5.46-2.7
					C143.75,174.43,139.15,162.29,142.39,150.72z"
        />
        <path
            fill="#3564F9"
            d="M151.03,137.29c9.19-7.74,22.15-8.58,32.24-2.08c1.71,1.1,3.3,2.4,4.72,3.85c1.46,1.5,3.67,1.87,5.51,0.92
					c0.74-0.38,1.35-0.94,1.79-1.61c0.34-0.53,0.57-1.13,0.68-1.78c0.24-1.49-0.23-2.98-1.29-4.07c-1.9-1.95-4.04-3.69-6.34-5.17
					c-13.38-8.61-31.22-7.44-43.38,2.84c-1.12,0.95-1.71,2.34-1.61,3.82c0.1,1.51,0.88,2.84,2.15,3.65
					C147.22,138.77,149.45,138.62,151.03,137.29z"
        />
        <path
            fill="#80AEFF"
            d="M171.76,188.68c-0.07,1.49,0.55,2.89,1.71,3.83c1.17,0.95,2.68,1.29,4.15,0.91
					c8.97-2.29,16.66-7.83,21.66-15.59c5-7.76,6.85-17.06,5.22-26.17c-0.27-1.49-1.2-2.73-2.55-3.4c-1.34-0.66-2.87-0.65-4.2,0.03
					c-1.83,0.94-2.82,2.95-2.45,5.01c1.21,6.78-0.17,13.7-3.88,19.48c-3.72,5.78-9.44,9.9-16.12,11.6
					C173.28,184.9,171.86,186.62,171.76,188.68z"
        />
        <path
            fill="#3564F9"
            d="M214.69,129.07l0.27-0.14c0.72-0.37,1.31-0.92,1.74-1.58c0.28-0.44,0.49-0.92,0.61-1.44
					c0.3-1.29,0.02-2.64-0.77-3.7c-4.28-5.74-9.51-10.62-15.55-14.51c-24.62-15.85-56.82-11.67-76.58,9.92
					c-0.92,1.01-1.35,2.37-1.17,3.73c0.18,1.37,0.95,2.59,2.11,3.33c1.92,1.23,4.41,0.92,5.94-0.75
					c16.67-18.24,43.86-21.76,64.65-8.38c5.06,3.25,9.44,7.34,13.04,12.14C210.31,129.51,212.72,130.08,214.69,129.07z"
        />
        <path
            fill="#80AEFF"
            d="M116.36,132c-1.31,0.4-2.37,1.36-2.91,2.61c-11.47,26.92-1.93,57.97,22.69,73.81
					c6.05,3.89,12.66,6.63,19.65,8.15c1.29,0.28,2.64-0.02,3.69-0.83c0.42-0.32,0.78-0.71,1.06-1.15c0.43-0.66,0.68-1.43,0.72-2.24
					l0.01-0.3c0.11-2.21-1.42-4.17-3.62-4.65c-5.86-1.29-11.39-3.59-16.45-6.84c-20.79-13.38-28.84-39.59-19.15-62.31
					c0.89-2.08,0.14-4.48-1.78-5.71C119.11,131.79,117.69,131.6,116.36,132z"
        />
        <path
            fill="#80AEFF"
            d="M218.92,190.48c9.64-14.98,12.09-33.37,6.71-50.44c-0.41-1.29-1.37-2.34-2.63-2.87
					c-1.28-0.54-2.72-0.48-3.95,0.16c-2.03,1.04-3.01,3.36-2.33,5.5c4.55,14.42,2.49,29.94-5.66,42.59
					c-8.14,12.65-21.42,20.96-36.43,22.79c-2.23,0.27-3.93,2.12-4.04,4.4c-0.07,1.38,0.48,2.72,1.49,3.66c1,0.93,2.35,1.37,3.7,1.2
					C193.56,215.3,209.28,205.46,218.92,190.48z"
        />
        <path
            fill="#3564F9"
            d="M106.25,106.1c-0.88,1.05-1.25,2.41-1.05,3.75c0.2,1.32,0.96,2.49,2.09,3.22c1.98,1.28,4.63,0.86,6.16-0.98
					c23.14-27.79,63.54-33.98,93.97-14.39c8.15,5.24,15.03,11.95,20.45,19.92c1.34,1.97,3.93,2.65,6.03,1.57
					c0.74-0.38,1.35-0.94,1.79-1.63c0.27-0.42,0.47-0.88,0.6-1.38c0.33-1.3,0.09-2.68-0.66-3.79c-6.13-9.03-13.91-16.62-23.14-22.56
					C178.07,67.7,132.4,74.69,106.25,106.1z"
        />
        <path
            fill="#80AEFF"
            d="M238.14,127.51c-2.09,1.07-3.05,3.57-2.23,5.8c7.82,21.37,5.27,44.55-6.99,63.61
					c-12.27,19.06-32.31,30.98-55,32.7c-2.37,0.18-4.25,2.09-4.36,4.43c-0.06,1.33,0.45,2.63,1.41,3.56
					c0.97,0.94,2.29,1.42,3.64,1.32c25.65-1.95,48.31-15.42,62.17-36.96c13.86-21.54,16.74-47.74,7.9-71.89
					c-0.47-1.27-1.45-2.28-2.71-2.77C240.72,126.83,239.33,126.9,238.14,127.51z"
        />
        <path
            fill="#80AEFF"
            d="M129.7,218.43c-30.43-19.58-41.52-58.92-25.82-91.49c1.04-2.15,0.32-4.73-1.66-6.01
					c-1.12-0.72-2.51-0.93-3.79-0.57c-1.3,0.37-2.39,1.28-2.98,2.51c-17.76,36.82-5.21,81.28,29.19,103.42
					c9.23,5.94,19.36,9.88,30.11,11.72c1.32,0.23,2.68-0.13,3.73-0.96c0.4-0.32,0.73-0.7,1-1.11c0.44-0.68,0.7-1.48,0.74-2.3
					c0.11-2.35-1.57-4.43-3.92-4.84C146.8,227.16,137.85,223.67,129.7,218.43z"
        />
    </SVGBase>
);

export default NewReleaseSustain;
